<app-message
    [successMessage]="false"
    [messageTitle]="'messages.page-not-found.title' | translate"
    [message]="'messages.page-not-found.description' | translate"
>
</app-message>
